import { AnchorButton, Tooltip } from "@blueprintjs/core"
import React from "react"

import styles from "./IntegrationSyncNowButton.module.css"

import { showToast } from "~/containers/ToasterContainer"

import { useSyncIntegration } from "./hooks/useSyncIntegration"

type TooltipContentProps = {
  isActive: boolean
  isSyncing: boolean
}

const TooltipContent = (props: TooltipContentProps) => {
  const { isActive, isSyncing } = props
  if (!isActive) {
    return <span>Cannot sync integration while it is paused.</span>
  }
  if (isSyncing) {
    return <span>Integration is currently syncing...</span>
  }
  return <span>Sync the integration now</span>
}

type IntegrationSyncNowButtonProps = {
  integration: {
    id: number
    active: boolean
  }
  lastIntegrationSync: {
    finished_at: null | string
  }
}

const IntegrationSyncNowButton = (props: IntegrationSyncNowButtonProps) => {
  const { integration, lastIntegrationSync } = props
  const [sync, isInFlight] = useSyncIntegration()

  const isSyncing = lastIntegrationSync && !lastIntegrationSync.finished_at

  const handleClick = async () => {
    showToast({
      message: "Syncing integration...",
      type: "success",
    })
    await sync({ integrationId: integration.id })
  }

  return (
    <Tooltip
      content={
        <TooltipContent isActive={integration.active} isSyncing={isSyncing} />
      }
    >
      <AnchorButton
        className={styles.button}
        onClick={handleClick}
        disabled={!integration.active || isSyncing || isInFlight}
        minimal
      >
        Sync Now
      </AnchorButton>
    </Tooltip>
  )
}

export { IntegrationSyncNowButton }
